import { render, staticRenderFns } from "./OrganizationPartnerApiConfig.vue?vue&type=template&id=dbbffad8&scoped=true"
import script from "./OrganizationPartnerApiConfig.vue?vue&type=script&lang=js"
export * from "./OrganizationPartnerApiConfig.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPartnerApiConfig.vue?vue&type=style&index=0&id=dbbffad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbffad8",
  null
  
)

export default component.exports